<template>
	<label
		class="flex items-center text-blue-400 hover:text-blue-400 bg-slate-50 border border-blue-300 rounded-md hover:shadow-md transition w-full overflow-hidden">
		<div class="flex items-start w-full">
			<select v-model="selectedValue" @change="emitValueChange" class="bg-slate-50 border-none focus:ring-0 w-full p-2 resize-none">
				<option :value="null">
					{{ placeholder }}
				</option>
				<option v-for="item in items" :key="item.id || item.value" :value="item.value || item.id">
					{{ prefix }} {{ item.name || `${item.first_name} ${item.last_name}` }}
				</option>
			</select>
		</div>
	</label>
</template>

<script setup>
	import { ref, watch } from 'vue';

	const props = defineProps({
		items: {
			type: Array,
			default: () => [],
		},
		prefix: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			default: 'Champ',
		},
		value: {
			type: [String, Number],
			default: null,
		},
	});

	const emit = defineEmits(['valueChange']);

	const selectedValue = ref(props.value);

	watch(
		() => props.value,
		(newValue) => {
			selectedValue.value = newValue;
		},
	);

	const emitValueChange = () => {
		emit('valueChange', selectedValue.value);
	};
</script>
